const localizationValues = {
    aumico_notes_word_in: 'in',
} as const;

type PickTypeOfKey<T> = {
    [P in keyof T]: P;
};

// just getting the value of the key
export const localizationKeys = Object.entries(localizationValues).reduce((acc, [key, value]) => {
    acc[key] = key;
    return acc;
}, {} as PickTypeOfKey<typeof localizationValues>);

export const localizationKeysDefaultValues = [
    { aumico_button_cancel: 'Empfänger' },
    { aumico_button_save: 'Empfänger' },
    { aumico_core_form_invalid_error: 'This field is invalid' },
    { aumico_core_form_mandatory_error: 'This field is mandatory' },
    { aumico_notes_component_options_add_more: 'Add more' },
    { aumico_notes_component_options_current_value_title_1: 'Current Value Title 1' },
    { aumico_notes_component_options_current_value_title_2: 'Current Value Title 2' },
    { aumico_notes_component_options_previous_value_title_1: 'Previous Value Title 1' },
    { aumico_notes_component_options_previous_value_title_2: 'Previous Value Title 2' },
    { aumico_notes_component_options_selection_option: 'Selection Option' },
    { aumico_notes_component_options_text_title: 'Text Title' },
    { aumico_notes_equity: 'Equity' },
    { aumico_notes_fli: 'Financial Line Item' },
    { aumico_notes_free_table_with_amounts: 'Free table with amounts' },
    { aumico_notes_name_exist_error: 'Name already exists' },
    {
        aumico_notes_notestemplate_form_legal_form_and_accounting_basis_combination_exist:
            'This combination of selected legal form and account basis already exist',
    },
    { aumico_notes_notestemplate_list_add_new: 'Add new notes template' },
    { aumico_notes_notestype_form_components: 'Components' },
    { aumico_notes_notestype_form_min_length_error: 'The minimum length is 5 characters' },
    { aumico_notes_notestype_form_name: 'Name' },
    { aumico_notes_notestype_form_title: 'Title' },
    { aumico_notes_notestype_list_add_new: 'Add new notes type' },
    { aumico_notes_options: 'Options' },
    { aumico_notes_preview: 'Preview' },
    { aumico_notes_rich_text: 'Rich Text' },
    { aumico_notes_select: 'Select' },
    { aumico_notes_server_error: 'Internal Server Error' },
    { aumico_notes_table_with_form_no_properties_error: 'No properties defined' },
    { aumico_notes_table_with_form_total: 'Total' },
    { aumico_notes_template: 'Notes Template' },
    { aumico_notes_testing_procedure_comment: 'Comment' },
    { aumico_notes_testing_procedure_flis: 'Flis' },
    { aumico_notes_testing_procedure_references: 'References' },
    { aumico_notes_testing_procedure: 'Testing Procedure' },
    { aumico_notes_text: 'Text' },
    { aumico_notes_total_row: 'Total Row' },
    { aumico_notes_types: 'Notes Types' },
    { aumico_notes_fli_component_add_more: 'Add more' },
    { aumico_notes_table_with_form_no_properties_defined: 'No properties defined.' },
    { aumico_notes_table_with_form_no_formfield_defined: 'NO FORM FIELD DEFINED FOR. ' },
    { aumico_notes_notespage_notes_not_found: 'There is no notes found by this legal form and account basis.' },
    { aumico_notes_notestype_form_information: 'Information' },
    { aumico_notes_table_with_form_enter_placeholder: 'Enter...' },
    { aumico_notes_rich_text_placeholder: 'Insert text here' },
    { aumico_notes_component_options_movementschedule_column1: 'Column 1' },
    { aumico_notes_component_options_movementschedule_column2: 'Column 2' },
    { aumico_notes_component_options_movementschedule_column3: 'Column 3' },
    { aumico_notes_component_options_movementschedule_column4: 'Column 4' },
    {
        aumico_notes_preview_attention:
            'Attention: This section to show only how the component looks like and any change in it will not reflect on the saved data',
    },
];

localizationKeysDefaultValues.push(
    ...Object.entries(localizationValues).map(([key, value]) => {
        const item = {} as any;
        item[key] = value;
        return item;
    }),
);
